import _ from 'lodash';
import {SnackbarState} from '~/redux/reducers/SnackbarReducer';

export enum SNACKBAR_ACTION {
    CLEAR_SNACKBAR = 'CLEAR_SNACKBAR',
    SHOW_SNACKBAR = 'SHOW_SNACKBAR',
}

export interface SnackbarActionValue {
    action: () => void;
    options?: SnackbarState;
}

const {CLEAR_SNACKBAR, SHOW_SNACKBAR} = SNACKBAR_ACTION;

export const clearSnackbar = () => ({
    type: CLEAR_SNACKBAR,
});

export const showSnackbar = (options?: Partial<SnackbarState>) => {
    const optionsPassed = _.omitBy(options, _.isUndefined);

    return {
        type: SHOW_SNACKBAR,
        value: optionsPassed,
    };
};
